import script from "./SelectDefault.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectDefault.vue?vue&type=script&lang=ts&setup=true"

import "./SelectDefault.vue?vue&type=style&index=0&id=3e16c9fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e16c9fd"]])

export default __exports__